module.exports = __webpack_public_path__ + "static/beauty3-9d93c24e58592d2739b387b9741e333c.jpg";